import React, { MouseEventHandler, ReactNode } from 'react';
import classNames from 'classnames';
import XIcon from 'icons/X.icon';
import { Button } from 'ncoded-component-library';
import { IconProp } from 'models/Icon';
import { ElementPosition } from 'models/Position';

import './ActionMenu.styles.scss';

type ActionType = {
  alert?: boolean;
  disabled?: boolean;
  className?: string;
  icon: IconProp | ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

type ActionMenuProps = {
  className?: string;
  actions: ActionType[];
  label: string;
  position?: ElementPosition;
  onClose: () => void;
};

const ActionMenu: React.FC<ActionMenuProps> = (props) => {
  const { className, label, actions, position = {}, onClose } = props;

  const classes = classNames('action-menu', className);

  return (
    <div className={classes} style={position}>
      <p>{label}</p>

      {actions.map(({ onClick, icon, className, alert, disabled }, index) => (
        <Button
          key={index}
          disabled={disabled}
          variant="icon"
          icon={icon}
          className={classNames(className, { alert })}
          onClick={onClick}
        />
      ))}

      <Button variant="icon" icon={XIcon} className="close" onClick={onClose} />
    </div>
  );
};

export default ActionMenu;
